import { API } from "../../backend";

export const isAuthenticated = () => {
  if (typeof window == "undefined") {
    return false;
  }
  if (localStorage.getItem("jwt")) {
    // @ts-ignore
    return JSON.parse(localStorage.getItem("jwt"));
  } else {
    return false;
  }
};

export const signout = async (next: () => void) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("jwt");

    try {
      await fetch(`${API}/signout`, {
        method: "GET",
      });
      next();
    } catch (error) {
      console.log(error);
    }
  }
};

export const checkForAdmin = ({ role }: { role: number }) => {
  return !(role < 1);
};

export const checkForSuperAdmin = ({ role }: { role: number }) => {
  return !(role < 2);
};
